export const emojis: { [name: string]: string } = {
  // Commonly-used
  white_check_mark: '✅',
  rocket: '🚀',
  '+1': '👍',
  alarm_clock: '⏰',
  full_moon_with_face: '🌝',

  // Smileys & Emotion
  grinning: '😀',
  smiley: '😃',
  smile: '😄',
  grin: '😁',
  laughing: '😆',
  sweat_smile: '😅',
  rolling_on_the_floor_laughing: '🤣',
  joy: '😂',
  slightly_smiling_face: '🙂',
  upside_down_face: '🙃',
  wink: '😉',
  blush: '😊',
  innocent: '😇',
  smiling_face_with_3_hearts: '🥰',
  heart_eyes: '😍',
  star_struck: '🤩',
  kissing_heart: '😘',
  kissing: '😗',
  kissing_closed_eyes: '😚',
  kissing_smiling_eyes: '😙',
  yum: '😋',
  stuck_out_tongue: '😛',
  stuck_out_tongue_winking_eye: '😜',
  zany_face: '🤪',
  stuck_out_tongue_closed_eyes: '😝',
  money_mouth_face: '🤑',
  hugging_face: '🤗',
  face_with_hand_over_mouth: '🤭',
  shushing_face: '🤫',
  thinking_face: '🤔',
  zipper_mouth_face: '🤐',
  face_with_raised_eyebrow: '🤨',
  neutral_face: '😐',
  expressionless: '😑',
  no_mouth: '😶',
  smirk: '😏',
  unamused: '😒',
  face_with_rolling_eyes: '🙄',
  grimacing: '😬',
  lying_face: '🤥',
  relieved: '😌',
  pensive: '😔',
  sleepy: '😪',
  drooling_face: '🤤',
  sleeping: '😴',
  mask: '😷',
  face_with_thermometer: '🤒',
  face_with_head_bandage: '🤕',
  nauseated_face: '🤢',
  face_vomiting: '🤮',
  sneezing_face: '🤧',
  hot_face: '🥵',
  cold_face: '🥶',
  woozy_face: '🥴',
  dizzy_face: '😵',
  exploding_head: '🤯',
  face_with_cowboy_hat: '🤠',
  partying_face: '🥳',
  sunglasses: '😎',
  nerd_face: '🤓',
  face_with_monocle: '🧐',
  confused: '😕',
  worried: '😟',
  slightly_frowning_face: '🙁',
  white_frowning_face: '☹️',
  open_mouth: '😮',
  hushed: '😯',
  astonished: '😲',
  flushed: '😳',
  pleading_face: '🥺',
  frowning: '😦',
  anguished: '😧',
  fearful: '😨',
  cold_sweat: '😰',
  disappointed_relieved: '😥',
  cry: '😢',
  sob: '😭',
  scream: '😱',
  confounded: '😖',
  persevere: '😣',
  disappointed: '😞',
  sweat: '😓',
  weary: '😩',
  tired_face: '😫',
  yawning_face: '🥱',
  triumph: '😤',
  rage: '😡',
  angry: '😠',
  face_with_symbols_on_mouth: '🤬',
  smiling_imp: '😈',
  imp: '👿',
  skull: '💀',
  skull_and_crossbones: '☠️',
  hankey: '💩',
  clown_face: '🤡',
  japanese_ogre: '👹',
  japanese_goblin: '👺',
  ghost: '👻',
  alien: '👽',
  space_invader: '👾',
  robot_face: '🤖',
  smiley_cat: '😺',
  smile_cat: '😸',
  joy_cat: '😹',
  heart_eyes_cat: '😻',
  smirk_cat: '😼',
  kissing_cat: '😽',
  scream_cat: '🙀',
  crying_cat_face: '😿',
  pouting_cat: '😾',
  see_no_evil: '🙈',
  hear_no_evil: '🙉',
  speak_no_evil: '🙊',
  kiss: '💋',
  love_letter: '💌',
  cupid: '💘',
  gift_heart: '💝',
  sparkling_heart: '💖',
  heartpulse: '💗',
  heartbeat: '💓',
  revolving_hearts: '💞',
  two_hearts: '💕',
  heart_decoration: '💟',
  heavy_heart_exclamation_mark_ornament: '❣️',
  broken_heart: '💔',
  heart: '❤️',
  orange_heart: '🧡',
  yellow_heart: '💛',
  green_heart: '💚',
  blue_heart: '💙',
  purple_heart: '💜',
  brown_heart: '🤎',
  black_heart: '🖤',
  white_heart: '🤍',
  _100: '💯',
  anger: '💢',
  boom: '💥',
  dizzy: '💫',
  sweat_drops: '💦',
  dash: '💨',
  hole: '🕳️',
  bomb: '💣',
  speech_balloon: '💬',
  eye_in_speech_bubble: '👁️‍🗨️',
  left_speech_bubble: '🗨️',
  right_anger_bubble: '🗯️',
  thought_balloon: '💭',
  zzz: '💤',
  // People & Body
  wave: '👋',
  raised_back_of_hand: '🤚',
  raised_hand_with_fingers_splayed: '🖐️',
  hand: '✋',
  spock_hand: '🖖',
  ok_hand: '👌',
  pinching_hand: '🤏',
  v: '✌️',
  crossed_fingers: '🤞',
  i_love_you_hand_sign: '🤟',
  the_horns: '🤘',
  call_me_hand: '🤙',
  point_left: '👈',
  point_right: '👉',
  point_up_2: '👆',
  middle_finger: '🖕',
  point_down: '👇',
  point_up: '☝️',
  '-1': '👎',
  fist: '✊',
  facepunch: '👊',
  left_facing_fist: '🤛',
  right_facing_fist: '🤜',
  clap: '👏',
  raised_hands: '🙌',
  open_hands: '👐',
  palms_up_together: '🤲',
  handshake: '🤝',
  pray: '🙏',
  writing_hand: '✍️',
  nail_care: '💅',
  selfie: '🤳',
  muscle: '💪',
  mechanical_arm: '🦾',
  mechanical_leg: '🦿',
  leg: '🦵',
  foot: '🦶',
  ear: '👂',
  ear_with_hearing_aid: '🦻',
  nose: '👃',
  brain: '🧠',
  tooth: '🦷',
  bone: '🦴',
  eyes: '👀',
  eye: '👁️',
  tongue: '👅',
  lips: '👄',
  baby: '👶',
  child: '🧒',
  boy: '👦',
  girl: '👧',
  adult: '🧑',
  person_with_blond_hair: '👱',
  man: '👨',
  bearded_person: '🧔',
  red_haired_man: '👨‍🦰',
  curly_haired_man: '👨‍🦱',
  white_haired_man: '👨‍🦳',
  bald_man: '👨‍🦲',
  woman: '👩',
  red_haired_woman: '👩‍🦰',
  red_haired_person: '🧑‍🦰',
  curly_haired_woman: '👩‍🦱',
  curly_haired_person: '🧑‍🦱',
  white_haired_woman: '👩‍🦳',
  white_haired_person: '🧑‍🦳',
  bald_woman: '👩‍🦲',
  bald_person: '🧑‍🦲',
  blond_haired_woman: '👱‍♀️',
  blond_haired_man: '👱‍♂️',
  older_adult: '🧓',
  older_man: '👴',
  older_woman: '👵',
  person_frowning: '🙍',
  man_frowning: '🙍‍♂️',
  woman_frowning: '🙍‍♀️',
  person_with_pouting_face: '🙎',
  man_pouting: '🙎‍♂️',
  woman_pouting: '🙎‍♀️',
  no_good: '🙅',
  man_gesturing_no: '🙅‍♂️',
  woman_gesturing_no: '🙅‍♀️',
  ok_woman: '🙆',
  man_gesturing_ok: '🙆‍♂️',
  woman_gesturing_ok: '🙆‍♀️',
  information_desk_person: '💁',
  man_tipping_hand: '💁‍♂️',
  woman_tipping_hand: '💁‍♀️',
  raising_hand: '🙋',
  man_raising_hand: '🙋‍♂️',
  woman_raising_hand: '🙋‍♀️',
  deaf_person: '🧏',
  deaf_man: '🧏‍♂️',
  deaf_woman: '🧏‍♀️',
  bow: '🙇',
  man_bowing: '🙇‍♂️',
  woman_bowing: '🙇‍♀️',
  face_palm: '🤦',
  man_facepalming: '🤦‍♂️',
  woman_facepalming: '🤦‍♀️',
  shrug: '🤷',
  man_shrugging: '🤷‍♂️',
  woman_shrugging: '🤷‍♀️',
  health_worker: '🧑‍⚕️',
  male_doctor: '👨‍⚕️',
  female_doctor: '👩‍⚕️',
  student: '🧑‍🎓',
  male_student: '👨‍🎓',
  female_student: '👩‍🎓',
  teacher: '🧑‍🏫',
  male_teacher: '👨‍🏫',
  female_teacher: '👩‍🏫',
  judge: '🧑‍⚖️',
  male_judge: '👨‍⚖️',
  female_judge: '👩‍⚖️',
  farmer: '🧑‍🌾',
  male_farmer: '👨‍🌾',
  female_farmer: '👩‍🌾',
  cook: '🧑‍🍳',
  male_cook: '👨‍🍳',
  female_cook: '👩‍🍳',
  mechanic: '🧑‍🔧',
  male_mechanic: '👨‍🔧',
  female_mechanic: '👩‍🔧',
  factory_worker: '🧑‍🏭',
  male_factory_worker: '👨‍🏭',
  female_factory_worker: '👩‍🏭',
  office_worker: '🧑‍💼',
  male_office_worker: '👨‍💼',
  female_office_worker: '👩‍💼',
  scientist: '🧑‍🔬',
  male_scientist: '👨‍🔬',
  female_scientist: '👩‍🔬',
  technologist: '🧑‍💻',
  male_technologist: '👨‍💻',
  female_technologist: '👩‍💻',
  singer: '🧑‍🎤',
  male_singer: '👨‍🎤',
  female_singer: '👩‍🎤',
  artist: '🧑‍🎨',
  male_artist: '👨‍🎨',
  female_artist: '👩‍🎨',
  pilot: '🧑‍✈️',
  male_pilot: '👨‍✈️',
  female_pilot: '👩‍✈️',
  astronaut: '🧑‍🚀',
  male_astronaut: '👨‍🚀',
  female_astronaut: '👩‍🚀',
  firefighter: '🧑‍🚒',
  male_firefighter: '👨‍🚒',
  female_firefighter: '👩‍🚒',
  cop: '👮',
  male_police_officer: '👮‍♂️',
  female_police_officer: '👮‍♀️',
  sleuth_or_spy: '🕵️',
  male_detective: '🕵️‍♂️',
  female_detective: '🕵️‍♀️',
  guardsman: '💂',
  male_guard: '💂‍♂️',
  female_guard: '💂‍♀️',
  construction_worker: '👷',
  male_construction_worker: '👷‍♂️',
  female_construction_worker: '👷‍♀️',
  prince: '🤴',
  princess: '👸',
  man_with_turban: '👳',
  man_wearing_turban: '👳‍♂️',
  woman_wearing_turban: '👳‍♀️',
  man_with_gua_pi_mao: '👲',
  person_with_headscarf: '🧕',
  man_in_tuxedo: '🤵',
  bride_with_veil: '👰',
  pregnant_woman: '🤰',
  breast_feeding: '🤱',
  angel: '👼',
  santa: '🎅',
  mrs_claus: '🤶',
  superhero: '🦸',
  male_superhero: '🦸‍♂️',
  female_superhero: '🦸‍♀️',
  supervillain: '🦹',
  male_supervillain: '🦹‍♂️',
  female_supervillain: '🦹‍♀️',
  mage: '🧙',
  male_mage: '🧙‍♂️',
  female_mage: '🧙‍♀️',
  fairy: '🧚',
  male_fairy: '🧚‍♂️',
  female_fairy: '🧚‍♀️',
  vampire: '🧛',
  male_vampire: '🧛‍♂️',
  female_vampire: '🧛‍♀️',
  merperson: '🧜',
  merman: '🧜‍♂️',
  mermaid: '🧜‍♀️',
  elf: '🧝',
  male_elf: '🧝‍♂️',
  female_elf: '🧝‍♀️',
  genie: '🧞',
  male_genie: '🧞‍♂️',
  female_genie: '🧞‍♀️',
  zombie: '🧟',
  male_zombie: '🧟‍♂️',
  female_zombie: '🧟‍♀️',
  massage: '💆',
  man_getting_massage: '💆‍♂️',
  woman_getting_massage: '💆‍♀️',
  haircut: '💇',
  man_getting_haircut: '💇‍♂️',
  woman_getting_haircut: '💇‍♀️',
  walking: '🚶',
  man_walking: '🚶‍♂️',
  woman_walking: '🚶‍♀️',
  standing_person: '🧍',
  man_standing: '🧍‍♂️',
  woman_standing: '🧍‍♀️',
  kneeling_person: '🧎',
  man_kneeling: '🧎‍♂️',
  woman_kneeling: '🧎‍♀️',
  person_with_probing_cane: '🧑‍🦯',
  man_with_probing_cane: '👨‍🦯',
  woman_with_probing_cane: '👩‍🦯',
  person_in_motorized_wheelchair: '🧑‍🦼',
  man_in_motorized_wheelchair: '👨‍🦼',
  woman_in_motorized_wheelchair: '👩‍🦼',
  person_in_manual_wheelchair: '🧑‍🦽',
  man_in_manual_wheelchair: '👨‍🦽',
  woman_in_manual_wheelchair: '👩‍🦽',
  runner: '🏃',
  man_running: '🏃‍♂️',
  woman_running: '🏃‍♀️',
  dancer: '💃',
  man_dancing: '🕺',
  man_in_business_suit_levitating: '🕴️',
  dancers: '👯',
  man_with_bunny_ears_partying: '👯‍♂️',
  woman_with_bunny_ears_partying: '👯‍♀️',
  person_in_steamy_room: '🧖',
  man_in_steamy_room: '🧖‍♂️',
  woman_in_steamy_room: '🧖‍♀️',
  person_climbing: '🧗',
  man_climbing: '🧗‍♂️',
  woman_climbing: '🧗‍♀️',
  fencer: '🤺',
  horse_racing: '🏇',
  skier: '⛷️',
  snowboarder: '🏂',
  golfer: '🏌️',
  man_golfing: '🏌️‍♂️',
  woman_golfing: '🏌️‍♀️',
  surfer: '🏄',
  man_surfing: '🏄‍♂️',
  woman_surfing: '🏄‍♀️',
  rowboat: '🚣',
  man_rowing_boat: '🚣‍♂️',
  woman_rowing_boat: '🚣‍♀️',
  swimmer: '🏊',
  man_swimming: '🏊‍♂️',
  woman_swimming: '🏊‍♀️',
  person_with_ball: '⛹️',
  man_bouncing_ball: '⛹️‍♂️',
  woman_bouncing_ball: '⛹️‍♀️',
  weight_lifter: '🏋️',
  man_lifting_weights: '🏋️‍♂️',
  woman_lifting_weights: '🏋️‍♀️',
  bicyclist: '🚴',
  man_biking: '🚴‍♂️',
  woman_biking: '🚴‍♀️',
  mountain_bicyclist: '🚵',
  man_mountain_biking: '🚵‍♂️',
  woman_mountain_biking: '🚵‍♀️',
  person_doing_cartwheel: '🤸',
  man_cartwheeling: '🤸‍♂️',
  woman_cartwheeling: '🤸‍♀️',
  wrestlers: '🤼',
  man_wrestling: '🤼‍♂️',
  woman_wrestling: '🤼‍♀️',
  water_polo: '🤽',
  man_playing_water_polo: '🤽‍♂️',
  woman_playing_water_polo: '🤽‍♀️',
  handball: '🤾',
  man_playing_handball: '🤾‍♂️',
  woman_playing_handball: '🤾‍♀️',
  juggling: '🤹',
  man_juggling: '🤹‍♂️',
  woman_juggling: '🤹‍♀️',
  person_in_lotus_position: '🧘',
  man_in_lotus_position: '🧘‍♂️',
  woman_in_lotus_position: '🧘‍♀️',
  bath: '🛀',
  sleeping_accommodation: '🛌',
  people_holding_hands: '🧑‍🤝‍🧑',
  two_women_holding_hands: '👭',
  couple: '👫',
  two_men_holding_hands: '👬',
  couplekiss: '💏',
  woman_kiss_man: '👩‍❤️‍💋‍👨',
  man_kiss_man: '👨‍❤️‍💋‍👨',
  woman_kiss_woman: '👩‍❤️‍💋‍👩',
  couple_with_heart: '💑',
  woman_heart_man: '👩‍❤️‍👨',
  man_heart_man: '👨‍❤️‍👨',
  woman_heart_woman: '👩‍❤️‍👩',
  family: '👪',
  man_woman_boy: '👨‍👩‍👦',
  man_woman_girl: '👨‍👩‍👧',
  man_woman_girl_boy: '👨‍👩‍👧‍👦',
  man_woman_boy_boy: '👨‍👩‍👦‍👦',
  man_woman_girl_girl: '👨‍👩‍👧‍👧',
  man_man_boy: '👨‍👨‍👦',
  man_man_girl: '👨‍👨‍👧',
  man_man_girl_boy: '👨‍👨‍👧‍👦',
  man_man_boy_boy: '👨‍👨‍👦‍👦',
  man_man_girl_girl: '👨‍👨‍👧‍👧',
  woman_woman_boy: '👩‍👩‍👦',
  woman_woman_girl: '👩‍👩‍👧',
  woman_woman_girl_boy: '👩‍👩‍👧‍👦',
  woman_woman_boy_boy: '👩‍👩‍👦‍👦',
  woman_woman_girl_girl: '👩‍👩‍👧‍👧',
  man_boy: '👨‍👦',
  man_boy_boy: '👨‍👦‍👦',
  man_girl: '👨‍👧',
  man_girl_boy: '👨‍👧‍👦',
  man_girl_girl: '👨‍👧‍👧',
  woman_boy: '👩‍👦',
  woman_boy_boy: '👩‍👦‍👦',
  woman_girl: '👩‍👧',
  woman_girl_boy: '👩‍👧‍👦',
  woman_girl_girl: '👩‍👧‍👧',
  speaking_head_in_silhouette: '🗣️',
  bust_in_silhouette: '👤',
  busts_in_silhouette: '👥',
  footprints: '👣',
  // Animals & Nature
  monkey_face: '🐵',
  monkey: '🐒',
  gorilla: '🦍',
  orangutan: '🦧',
  dog: '🐶',
  dog2: '🐕',
  guide_dog: '🦮',
  service_dog: '🐕‍🦺',
  poodle: '🐩',
  wolf: '🐺',
  fox_face: '🦊',
  raccoon: '🦝',
  cat: '🐱',
  cat2: '🐈',
  lion_face: '🦁',
  tiger: '🐯',
  tiger2: '🐅',
  leopard: '🐆',
  horse: '🐴',
  racehorse: '🐎',
  unicorn_face: '🦄',
  zebra_face: '🦓',
  deer: '🦌',
  cow: '🐮',
  ox: '🐂',
  water_buffalo: '🐃',
  cow2: '🐄',
  pig: '🐷',
  pig2: '🐖',
  boar: '🐗',
  pig_nose: '🐽',
  ram: '🐏',
  sheep: '🐑',
  goat: '🐐',
  dromedary_camel: '🐪',
  camel: '🐫',
  llama: '🦙',
  giraffe_face: '🦒',
  elephant: '🐘',
  rhinoceros: '🦏',
  hippopotamus: '🦛',
  mouse: '🐭',
  mouse2: '🐁',
  rat: '🐀',
  hamster: '🐹',
  rabbit: '🐰',
  rabbit2: '🐇',
  chipmunk: '🐿️',
  hedgehog: '🦔',
  bat: '🦇',
  bear: '🐻',
  koala: '🐨',
  panda_face: '🐼',
  sloth: '🦥',
  otter: '🦦',
  skunk: '🦨',
  kangaroo: '🦘',
  badger: '🦡',
  feet: '🐾',
  turkey: '🦃',
  chicken: '🐔',
  rooster: '🐓',
  hatching_chick: '🐣',
  baby_chick: '🐤',
  hatched_chick: '🐥',
  bird: '🐦',
  penguin: '🐧',
  dove_of_peace: '🕊️',
  eagle: '🦅',
  duck: '🦆',
  swan: '🦢',
  owl: '🦉',
  flamingo: '🦩',
  peacock: '🦚',
  parrot: '🦜',
  frog: '🐸',
  crocodile: '🐊',
  turtle: '🐢',
  lizard: '🦎',
  snake: '🐍',
  dragon_face: '🐲',
  dragon: '🐉',
  sauropod: '🦕',
  t_rex: '🦖',
  whale: '🐳',
  whale2: '🐋',
  dolphin: '🐬',
  fish: '🐟',
  tropical_fish: '🐠',
  blowfish: '🐡',
  shark: '🦈',
  octopus: '🐙',
  shell: '🐚',
  snail: '🐌',
  butterfly: '🦋',
  bug: '🐛',
  ant: '🐜',
  bee: '🐝',
  beetle: '🐞',
  cricket: '🦗',
  spider: '🕷️',
  spider_web: '🕸️',
  scorpion: '🦂',
  mosquito: '🦟',
  microbe: '🦠',
  bouquet: '💐',
  cherry_blossom: '🌸',
  white_flower: '💮',
  rosette: '🏵️',
  rose: '🌹',
  wilted_flower: '🥀',
  hibiscus: '🌺',
  sunflower: '🌻',
  blossom: '🌼',
  tulip: '🌷',
  seedling: '🌱',
  evergreen_tree: '🌲',
  deciduous_tree: '🌳',
  palm_tree: '🌴',
  cactus: '🌵',
  ear_of_rice: '🌾',
  herb: '🌿',
  shamrock: '☘️',
  four_leaf_clover: '🍀',
  maple_leaf: '🍁',
  fallen_leaf: '🍂',
  leaves: '🍃',
  // Food & Drink
  grapes: '🍇',
  melon: '🍈',
  watermelon: '🍉',
  tangerine: '🍊',
  lemon: '🍋',
  banana: '🍌',
  pineapple: '🍍',
  mango: '🥭',
  apple: '🍎',
  green_apple: '🍏',
  pear: '🍐',
  peach: '🍑',
  cherries: '🍒',
  strawberry: '🍓',
  kiwifruit: '🥝',
  tomato: '🍅',
  coconut: '🥥',
  avocado: '🥑',
  eggplant: '🍆',
  potato: '🥔',
  carrot: '🥕',
  corn: '🌽',
  hot_pepper: '🌶️',
  cucumber: '🥒',
  leafy_green: '🥬',
  broccoli: '🥦',
  garlic: '🧄',
  onion: '🧅',
  mushroom: '🍄',
  peanuts: '🥜',
  chestnut: '🌰',
  bread: '🍞',
  croissant: '🥐',
  baguette_bread: '🥖',
  pretzel: '🥨',
  bagel: '🥯',
  pancakes: '🥞',
  waffle: '🧇',
  cheese_wedge: '🧀',
  meat_on_bone: '🍖',
  poultry_leg: '🍗',
  cut_of_meat: '🥩',
  bacon: '🥓',
  hamburger: '🍔',
  fries: '🍟',
  pizza: '🍕',
  hotdog: '🌭',
  sandwich: '🥪',
  taco: '🌮',
  burrito: '🌯',
  stuffed_flatbread: '🥙',
  falafel: '🧆',
  egg: '🥚',
  fried_egg: '🍳',
  shallow_pan_of_food: '🥘',
  stew: '🍲',
  bowl_with_spoon: '🥣',
  green_salad: '🥗',
  popcorn: '🍿',
  butter: '🧈',
  salt: '🧂',
  canned_food: '🥫',
  bento: '🍱',
  rice_cracker: '🍘',
  rice_ball: '🍙',
  rice: '🍚',
  curry: '🍛',
  ramen: '🍜',
  spaghetti: '🍝',
  sweet_potato: '🍠',
  oden: '🍢',
  sushi: '🍣',
  fried_shrimp: '🍤',
  fish_cake: '🍥',
  moon_cake: '🥮',
  dango: '🍡',
  dumpling: '🥟',
  fortune_cookie: '🥠',
  takeout_box: '🥡',
  crab: '🦀',
  lobster: '🦞',
  shrimp: '🦐',
  squid: '🦑',
  oyster: '🦪',
  icecream: '🍦',
  shaved_ice: '🍧',
  ice_cream: '🍨',
  doughnut: '🍩',
  cookie: '🍪',
  birthday: '🎂',
  cake: '🍰',
  cupcake: '🧁',
  pie: '🥧',
  chocolate_bar: '🍫',
  candy: '🍬',
  lollipop: '🍭',
  custard: '🍮',
  honey_pot: '🍯',
  baby_bottle: '🍼',
  glass_of_milk: '🥛',
  coffee: '☕',
  tea: '🍵',
  sake: '🍶',
  champagne: '🍾',
  wine_glass: '🍷',
  cocktail: '🍸',
  tropical_drink: '🍹',
  beer: '🍺',
  beers: '🍻',
  clinking_glasses: '🥂',
  tumbler_glass: '🥃',
  cup_with_straw: '🥤',
  beverage_box: '🧃',
  mate_drink: '🧉',
  ice_cube: '🧊',
  chopsticks: '🥢',
  knife_fork_plate: '🍽️',
  fork_and_knife: '🍴',
  spoon: '🥄',
  hocho: '🔪',
  amphora: '🏺',
  // Activities
  jack_o_lantern: '🎃',
  christmas_tree: '🎄',
  fireworks: '🎆',
  sparkler: '🎇',
  firecracker: '🧨',
  sparkles: '✨',
  balloon: '🎈',
  tada: '🎉',
  confetti_ball: '🎊',
  tanabata_tree: '🎋',
  bamboo: '🎍',
  dolls: '🎎',
  flags: '🎏',
  wind_chime: '🎐',
  rice_scene: '🎑',
  red_envelope: '🧧',
  ribbon: '🎀',
  gift: '🎁',
  reminder_ribbon: '🎗️',
  admission_tickets: '🎟️',
  ticket: '🎫',
  medal: '🎖️',
  trophy: '🏆',
  sports_medal: '🏅',
  first_place_medal: '🥇',
  second_place_medal: '🥈',
  third_place_medal: '🥉',
  soccer: '⚽',
  baseball: '⚾',
  softball: '🥎',
  basketball: '🏀',
  volleyball: '🏐',
  football: '🏈',
  rugby_football: '🏉',
  tennis: '🎾',
  flying_disc: '🥏',
  bowling: '🎳',
  cricket_bat_and_ball: '🏏',
  field_hockey_stick_and_ball: '🏑',
  ice_hockey_stick_and_puck: '🏒',
  lacrosse: '🥍',
  table_tennis_paddle_and_ball: '🏓',
  badminton_racquet_and_shuttlecock: '🏸',
  boxing_glove: '🥊',
  martial_arts_uniform: '🥋',
  goal_net: '🥅',
  golf: '⛳',
  ice_skate: '⛸️',
  fishing_pole_and_fish: '🎣',
  diving_mask: '🤿',
  running_shirt_with_sash: '🎽',
  ski: '🎿',
  sled: '🛷',
  curling_stone: '🥌',
  dart: '🎯',
  yo_yo: '🪀',
  kite: '🪁',
  '8ball': '🎱',
  crystal_ball: '🔮',
  nazar_amulet: '🧿',
  video_game: '🎮',
  joystick: '🕹️',
  slot_machine: '🎰',
  game_die: '🎲',
  jigsaw: '🧩',
  teddy_bear: '🧸',
  spades: '♠️',
  hearts: '♥️',
  diamonds: '♦️',
  clubs: '♣️',
  chess_pawn: '♟️',
  black_joker: '🃏',
  mahjong: '🀄',
  flower_playing_cards: '🎴',
  performing_arts: '🎭',
  frame_with_picture: '🖼️',
  art: '🎨',
  thread: '🧵',
  yarn: '🧶',
  // Travel & Places
  earth_africa: '🌍',
  earth_americas: '🌎',
  earth_asia: '🌏',
  globe_with_meridians: '🌐',
  world_map: '🗺️',
  japan: '🗾',
  compass: '🧭',
  snow_capped_mountain: '🏔️',
  mountain: '⛰️',
  volcano: '🌋',
  mount_fuji: '🗻',
  camping: '🏕️',
  beach_with_umbrella: '🏖️',
  desert: '🏜️',
  desert_island: '🏝️',
  national_park: '🏞️',
  stadium: '🏟️',
  classical_building: '🏛️',
  building_construction: '🏗️',
  bricks: '🧱',
  house_buildings: '🏘️',
  derelict_house_building: '🏚️',
  house: '🏠',
  house_with_garden: '🏡',
  office: '🏢',
  post_office: '🏣',
  european_post_office: '🏤',
  hospital: '🏥',
  bank: '🏦',
  hotel: '🏨',
  love_hotel: '🏩',
  convenience_store: '🏪',
  school: '🏫',
  department_store: '🏬',
  factory: '🏭',
  japanese_castle: '🏯',
  european_castle: '🏰',
  wedding: '💒',
  tokyo_tower: '🗼',
  statue_of_liberty: '🗽',
  church: '⛪',
  mosque: '🕌',
  hindu_temple: '🛕',
  synagogue: '🕍',
  shinto_shrine: '⛩️',
  kaaba: '🕋',
  fountain: '⛲',
  tent: '⛺',
  foggy: '🌁',
  night_with_stars: '🌃',
  cityscape: '🏙️',
  sunrise_over_mountains: '🌄',
  sunrise: '🌅',
  city_sunset: '🌆',
  city_sunrise: '🌇',
  bridge_at_night: '🌉',
  hotsprings: '♨️',
  carousel_horse: '🎠',
  ferris_wheel: '🎡',
  roller_coaster: '🎢',
  barber: '💈',
  circus_tent: '🎪',
  steam_locomotive: '🚂',
  railway_car: '🚃',
  bullettrain_side: '🚄',
  bullettrain_front: '🚅',
  train2: '🚆',
  metro: '🚇',
  light_rail: '🚈',
  station: '🚉',
  tram: '🚊',
  monorail: '🚝',
  mountain_railway: '🚞',
  train: '🚋',
  bus: '🚌',
  oncoming_bus: '🚍',
  trolleybus: '🚎',
  minibus: '🚐',
  ambulance: '🚑',
  fire_engine: '🚒',
  police_car: '🚓',
  oncoming_police_car: '🚔',
  taxi: '🚕',
  oncoming_taxi: '🚖',
  car: '🚗',
  oncoming_automobile: '🚘',
  blue_car: '🚙',
  truck: '🚚',
  articulated_lorry: '🚛',
  tractor: '🚜',
  racing_car: '🏎️',
  racing_motorcycle: '🏍️',
  motor_scooter: '🛵',
  manual_wheelchair: '🦽',
  motorized_wheelchair: '🦼',
  auto_rickshaw: '🛺',
  bike: '🚲',
  scooter: '🛴',
  skateboard: '🛹',
  busstop: '🚏',
  motorway: '🛣️',
  railway_track: '🛤️',
  oil_drum: '🛢️',
  fuelpump: '⛽',
  rotating_light: '🚨',
  traffic_light: '🚥',
  vertical_traffic_light: '🚦',
  octagonal_sign: '🛑',
  construction: '🚧',
  anchor: '⚓',
  boat: '⛵',
  canoe: '🛶',
  speedboat: '🚤',
  passenger_ship: '🛳️',
  ferry: '⛴️',
  motor_boat: '🛥️',
  ship: '🚢',
  airplane: '✈️',
  small_airplane: '🛩️',
  airplane_departure: '🛫',
  airplane_arriving: '🛬',
  parachute: '🪂',
  seat: '💺',
  helicopter: '🚁',
  suspension_railway: '🚟',
  mountain_cableway: '🚠',
  aerial_tramway: '🚡',
  satellite: '🛰️',
  flying_saucer: '🛸',
  bellhop_bell: '🛎️',
  luggage: '🧳',
  hourglass: '⌛',
  hourglass_flowing_sand: '⏳',
  watch: '⌚',
  stopwatch: '⏱️',
  timer_clock: '⏲️',
  mantelpiece_clock: '🕰️',
  clock12: '🕛',
  clock1230: '🕧',
  clock1: '🕐',
  clock130: '🕜',
  clock2: '🕑',
  clock230: '🕝',
  clock3: '🕒',
  clock330: '🕞',
  clock4: '🕓',
  clock430: '🕟',
  clock5: '🕔',
  clock530: '🕠',
  clock6: '🕕',
  clock630: '🕡',
  clock7: '🕖',
  clock730: '🕢',
  clock8: '🕗',
  clock830: '🕣',
  clock9: '🕘',
  clock930: '🕤',
  clock10: '🕙',
  clock1030: '🕥',
  clock11: '🕚',
  clock1130: '🕦',
  new_moon: '🌑',
  waxing_crescent_moon: '🌒',
  first_quarter_moon: '🌓',
  moon: '🌔',
  full_moon: '🌕',
  waning_gibbous_moon: '🌖',
  last_quarter_moon: '🌗',
  waning_crescent_moon: '🌘',
  crescent_moon: '🌙',
  new_moon_with_face: '🌚',
  first_quarter_moon_with_face: '🌛',
  last_quarter_moon_with_face: '🌜',
  thermometer: '🌡️',
  sunny: '☀️',
  sun_with_face: '🌞',
  ringed_planet: '🪐',
  star: '⭐',
  star2: '🌟',
  stars: '🌠',
  milky_way: '🌌',
  cloud: '☁️',
  partly_sunny: '⛅',
  thunder_cloud_and_rain: '⛈️',
  mostly_sunny: '🌤️',
  barely_sunny: '🌥️',
  partly_sunny_rain: '🌦️',
  rain_cloud: '🌧️',
  snow_cloud: '🌨️',
  lightning: '🌩️',
  tornado: '🌪️',
  fog: '🌫️',
  wind_blowing_face: '🌬️',
  cyclone: '🌀',
  rainbow: '🌈',
  closed_umbrella: '🌂',
  umbrella: '☂️',
  umbrella_with_rain_drops: '☔',
  umbrella_on_ground: '⛱️',
  zap: '⚡',
  snowflake: '❄️',
  snowman: '☃️',
  snowman_without_snow: '⛄',
  comet: '☄️',
  fire: '🔥',
  droplet: '💧',
  ocean: '🌊',
  // Symbols
  atm: '🏧',
  put_litter_in_its_place: '🚮',
  potable_water: '🚰',
  wheelchair: '♿',
  mens: '🚹',
  womens: '🚺',
  restroom: '🚻',
  baby_symbol: '🚼',
  wc: '🚾',
  passport_control: '🛂',
  customs: '🛃',
  baggage_claim: '🛄',
  left_luggage: '🛅',
  warning: '⚠️',
  children_crossing: '🚸',
  no_entry: '⛔',
  no_entry_sign: '🚫',
  no_bicycles: '🚳',
  no_smoking: '🚭',
  do_not_litter: '🚯',
  non_potable_water: '🚱',
  no_pedestrians: '🚷',
  no_mobile_phones: '📵',
  underage: '🔞',
  radioactive_sign: '☢️',
  biohazard_sign: '☣️',
  arrow_up: '⬆️',
  arrow_upper_right: '↗️',
  arrow_right: '➡️',
  arrow_lower_right: '↘️',
  arrow_down: '⬇️',
  arrow_lower_left: '↙️',
  arrow_left: '⬅️',
  arrow_upper_left: '↖️',
  arrow_up_down: '↕️',
  left_right_arrow: '↔️',
  leftwards_arrow_with_hook: '↩️',
  arrow_right_hook: '↪️',
  arrow_heading_up: '⤴️',
  arrow_heading_down: '⤵️',
  arrows_clockwise: '🔃',
  arrows_counterclockwise: '🔄',
  back: '🔙',
  end: '🔚',
  on: '🔛',
  soon: '🔜',
  top: '🔝',
  place_of_worship: '🛐',
  atom_symbol: '⚛️',
  om_symbol: '🕉️',
  star_of_david: '✡️',
  wheel_of_dharma: '☸️',
  yin_yang: '☯️',
  latin_cross: '✝️',
  orthodox_cross: '☦️',
  star_and_crescent: '☪️',
  peace_symbol: '☮️',
  menorah_with_nine_branches: '🕎',
  six_pointed_star: '🔯',
  aries: '♈',
  taurus: '♉',
  gemini: '♊',
  cancer: '♋',
  leo: '♌',
  virgo: '♍',
  libra: '♎',
  scorpius: '♏',
  sagittarius: '♐',
  capricorn: '♑',
  aquarius: '♒',
  pisces: '♓',
  ophiuchus: '⛎',
  twisted_rightwards_arrows: '🔀',
  repeat: '🔁',
  repeat_one: '🔂',
  arrow_forward: '▶️',
  fast_forward: '⏩',
  black_right_pointing_double_triangle_with_vertical_bar: '⏭️',
  black_right_pointing_triangle_with_double_vertical_bar: '⏯️',
  arrow_backward: '◀️',
  rewind: '⏪',
  black_left_pointing_double_triangle_with_vertical_bar: '⏮️',
  arrow_up_small: '🔼',
  arrow_double_up: '⏫',
  arrow_down_small: '🔽',
  arrow_double_down: '⏬',
  double_vertical_bar: '⏸️',
  black_square_for_stop: '⏹️',
  black_circle_for_record: '⏺️',
  eject: '⏏️',
  cinema: '🎦',
  low_brightness: '🔅',
  high_brightness: '🔆',
  signal_strength: '📶',
  vibration_mode: '📳',
  mobile_phone_off: '📴',
  female_sign: '♀️',
  male_sign: '♂️',
  medical_symbol: '⚕️',
  infinity: '♾️',
  recycle: '♻️',
  fleur_de_lis: '⚜️',
  trident: '🔱',
  name_badge: '📛',
  beginner: '🔰',
  o: '⭕',
  ballot_box_with_check: '☑️',
  heavy_check_mark: '✔️',
  heavy_multiplication_x: '✖️',
  x: '❌',
  negative_squared_cross_mark: '❎',
  heavy_plus_sign: '➕',
  heavy_minus_sign: '➖',
  heavy_division_sign: '➗',
  curly_loop: '➰',
  loop: '➿',
  part_alternation_mark: '〽️',
  eight_spoked_asterisk: '✳️',
  eight_pointed_black_star: '✴️',
  sparkle: '❇️',
  bangbang: '‼️',
  interrobang: '⁉️',
  question: '❓',
  grey_question: '❔',
  grey_exclamation: '❕',
  exclamation: '❗',
  wavy_dash: '〰️',
  copyright: '©️',
  registered: '®️',
  tm: '™️',
  hash: '#️⃣',
  keycap_star: '*️⃣',
  zero: '0️⃣',
  one: '1️⃣',
  two: '2️⃣',
  three: '3️⃣',
  four: '4️⃣',
  five: '5️⃣',
  six: '6️⃣',
  seven: '7️⃣',
  eight: '8️⃣',
  nine: '9️⃣',
  keycap_ten: '🔟',
  capital_abcd: '🔠',
  abcd: '🔡',
  _1234: '🔢',
  symbols: '🔣',
  abc: '🔤',
  a: '🅰️',
  ab: '🆎',
  b: '🅱️',
  cl: '🆑',
  cool: '🆒',
  free: '🆓',
  information_source: 'ℹ️',
  id: '🆔',
  m: 'Ⓜ️',
  new: '🆕',
  ng: '🆖',
  o2: '🅾️',
  ok: '🆗',
  parking: '🅿️',
  sos: '🆘',
  up: '🆙',
  vs: '🆚',
  koko: '🈁',
  sa: '🈂️',
  u6708: '🈷️',
  u6709: '🈶',
  u6307: '🈯',
  ideograph_advantage: '🉐',
  u5272: '🈹',
  u7121: '🈚',
  u7981: '🈲',
  accept: '🉑',
  u7533: '🈸',
  u5408: '🈴',
  u7a7a: '🈳',
  congratulations: '㊗️',
  secret: '㊙️',
  u55b6: '🈺',
  u6e80: '🈵',
  red_circle: '🔴',
  large_orange_circle: '🟠',
  large_yellow_circle: '🟡',
  large_green_circle: '🟢',
  large_blue_circle: '🔵',
  large_purple_circle: '🟣',
  large_brown_circle: '🟤',
  black_circle: '⚫',
  white_circle: '⚪',
  large_red_square: '🟥',
  large_orange_square: '🟧',
  large_yellow_square: '🟨',
  large_green_square: '🟩',
  large_blue_square: '🟦',
  large_purple_square: '🟪',
  large_brown_square: '🟫',
  black_large_square: '⬛',
  white_large_square: '⬜',
  black_medium_square: '◼️',
  white_medium_square: '◻️',
  black_medium_small_square: '◾',
  white_medium_small_square: '◽',
  black_small_square: '▪️',
  white_small_square: '▫️',
  large_orange_diamond: '🔶',
  large_blue_diamond: '🔷',
  small_orange_diamond: '🔸',
  small_blue_diamond: '🔹',
  small_red_triangle: '🔺',
  small_red_triangle_down: '🔻',
  diamond_shape_with_a_dot_inside: '💠',
  radio_button: '🔘',
  white_square_button: '🔳',
  black_square_button: '🔲',
  // Objects
  eyeglasses: '👓',
  dark_sunglasses: '🕶️',
  goggles: '🥽',
  lab_coat: '🥼',
  safety_vest: '🦺',
  necktie: '👔',
  shirt: '👕',
  jeans: '👖',
  scarf: '🧣',
  gloves: '🧤',
  coat: '🧥',
  socks: '🧦',
  dress: '👗',
  kimono: '👘',
  sari: '🥻',
  one_piece_swimsuit: '🩱',
  briefs: '🩲',
  shorts: '🩳',
  bikini: '👙',
  womans_clothes: '👚',
  purse: '👛',
  handbag: '👜',
  pouch: '👝',
  shopping_bags: '🛍️',
  school_satchel: '🎒',
  mans_shoe: '👞',
  athletic_shoe: '👟',
  hiking_boot: '🥾',
  womans_flat_shoe: '🥿',
  high_heel: '👠',
  sandal: '👡',
  ballet_shoes: '🩰',
  boot: '👢',
  crown: '👑',
  womans_hat: '👒',
  tophat: '🎩',
  mortar_board: '🎓',
  billed_cap: '🧢',
  helmet_with_white_cross: '⛑️',
  prayer_beads: '📿',
  lipstick: '💄',
  ring: '💍',
  gem: '💎',
  mute: '🔇',
  speaker: '🔈',
  sound: '🔉',
  loud_sound: '🔊',
  loudspeaker: '📢',
  mega: '📣',
  postal_horn: '📯',
  bell: '🔔',
  no_bell: '🔕',
  musical_score: '🎼',
  musical_note: '🎵',
  notes: '🎶',
  studio_microphone: '🎙️',
  level_slider: '🎚️',
  control_knobs: '🎛️',
  microphone: '🎤',
  headphones: '🎧',
  radio: '📻',
  saxophone: '🎷',
  guitar: '🎸',
  musical_keyboard: '🎹',
  trumpet: '🎺',
  violin: '🎻',
  banjo: '🪕',
  drum_with_drumsticks: '🥁',
  iphone: '📱',
  calling: '📲',
  phone: '☎️',
  telephone_receiver: '📞',
  pager: '📟',
  fax: '📠',
  battery: '🔋',
  electric_plug: '🔌',
  computer: '💻',
  desktop_computer: '🖥️',
  printer: '🖨️',
  keyboard: '⌨️',
  three_button_mouse: '🖱️',
  trackball: '🖲️',
  minidisc: '💽',
  floppy_disk: '💾',
  cd: '💿',
  dvd: '📀',
  abacus: '🧮',
  movie_camera: '🎥',
  film_frames: '🎞️',
  film_projector: '📽️',
  clapper: '🎬',
  tv: '📺',
  camera: '📷',
  camera_with_flash: '📸',
  video_camera: '📹',
  vhs: '📼',
  mag: '🔍',
  mag_right: '🔎',
  candle: '🕯️',
  bulb: '💡',
  flashlight: '🔦',
  izakaya_lantern: '🏮',
  diya_lamp: '🪔',
  notebook_with_decorative_cover: '📔',
  closed_book: '📕',
  book: '📖',
  green_book: '📗',
  blue_book: '📘',
  orange_book: '📙',
  books: '📚',
  notebook: '📓',
  ledger: '📒',
  page_with_curl: '📃',
  scroll: '📜',
  page_facing_up: '📄',
  newspaper: '📰',
  rolled_up_newspaper: '🗞️',
  bookmark_tabs: '📑',
  bookmark: '🔖',
  label: '🏷️',
  moneybag: '💰',
  yen: '💴',
  dollar: '💵',
  euro: '💶',
  pound: '💷',
  money_with_wings: '💸',
  credit_card: '💳',
  receipt: '🧾',
  chart: '💹',
  currency_exchange: '💱',
  heavy_dollar_sign: '💲',
  email: '✉️',
  incoming_envelope: '📨',
  envelope_with_arrow: '📩',
  outbox_tray: '📤',
  inbox_tray: '📥',
  package: '📦',
  mailbox: '📫',
  mailbox_closed: '📪',
  mailbox_with_mail: '📬',
  mailbox_with_no_mail: '📭',
  postbox: '📮',
  ballot_box_with_ballot: '🗳️',
  pencil2: '✏️',
  black_nib: '✒️',
  lower_left_fountain_pen: '🖋️',
  lower_left_ballpoint_pen: '🖊️',
  lower_left_paintbrush: '🖌️',
  lower_left_crayon: '🖍️',
  memo: '📝',
  briefcase: '💼',
  file_folder: '📁',
  open_file_folder: '📂',
  card_index_dividers: '🗂️',
  date: '📅',
  calendar: '📆',
  spiral_note_pad: '🗒️',
  spiral_calendar_pad: '🗓️',
  card_index: '📇',
  chart_with_upwards_trend: '📈',
  chart_with_downwards_trend: '📉',
  bar_chart: '📊',
  clipboard: '📋',
  pushpin: '📌',
  round_pushpin: '📍',
  paperclip: '📎',
  linked_paperclips: '🖇️',
  straight_ruler: '📏',
  triangular_ruler: '📐',
  scissors: '✂️',
  card_file_box: '🗃️',
  file_cabinet: '🗄️',
  wastebasket: '🗑️',
  lock: '🔒',
  unlock: '🔓',
  lock_with_ink_pen: '🔏',
  closed_lock_with_key: '🔐',
  key: '🔑',
  old_key: '🗝️',
  hammer: '🔨',
  axe: '🪓',
  pick: '⛏️',
  hammer_and_pick: '⚒️',
  hammer_and_wrench: '🛠️',
  dagger_knife: '🗡️',
  crossed_swords: '⚔️',
  gun: '🔫',
  bow_and_arrow: '🏹',
  shield: '🛡️',
  wrench: '🔧',
  nut_and_bolt: '🔩',
  gear: '⚙️',
  compression: '🗜️',
  scales: '⚖️',
  probing_cane: '🦯',
  link: '🔗',
  chains: '⛓️',
  toolbox: '🧰',
  magnet: '🧲',
  alembic: '⚗️',
  test_tube: '🧪',
  petri_dish: '🧫',
  dna: '🧬',
  microscope: '🔬',
  telescope: '🔭',
  satellite_antenna: '📡',
  syringe: '💉',
  drop_of_blood: '🩸',
  pill: '💊',
  adhesive_bandage: '🩹',
  stethoscope: '🩺',
  door: '🚪',
  bed: '🛏️',
  couch_and_lamp: '🛋️',
  chair: '🪑',
  toilet: '🚽',
  shower: '🚿',
  bathtub: '🛁',
  razor: '🪒',
  lotion_bottle: '🧴',
  safety_pin: '🧷',
  broom: '🧹',
  basket: '🧺',
  roll_of_paper: '🧻',
  soap: '🧼',
  sponge: '🧽',
  fire_extinguisher: '🧯',
  shopping_trolley: '🛒',
  smoking: '🚬',
  coffin: '⚰️',
  funeral_urn: '⚱️',
  moyai: '🗿',
};

export const emojiList = Object.entries(emojis);
